import type { HTMLAttributes } from 'react'
import { cn } from './cn'

export interface SparkbarsProps extends HTMLAttributes<HTMLDivElement> {
  data?: number[]
  onInk?: boolean
}

/** Tiny inline bar trend. `data` = numbers; last bar is highlighted. */
export function Sparkbars({ data = [], onInk = false, className = '', ...props }: SparkbarsProps) {
  const max = Math.max(1, ...data)
  const occurrences = new Map<number, number>()

  return (
    <div className={cn('flex items-end gap-[3px] h-9', className)} aria-hidden="true" {...props}>
      {data.map((value, i) => {
        const peak = i === data.length - 1
        const occurrence = occurrences.get(value) ?? 0
        occurrences.set(value, occurrence + 1)

        return (
          <i
            key={`${value}:${occurrence}`}
            className={cn('block w-1.5 rounded-t-sm', peak ? (onInk ? 'bg-mustard' : 'bg-chart-1') : onInk ? 'bg-veil-line' : 'bg-vjal-100')}
            style={{ blockSize: `${Math.round((value / max) * 100)}%` }}
          />
        )
      })}
    </div>
  )
}
